import { render, staticRenderFns } from "./SharedLinkDeleteDialogBox.vue?vue&type=template&id=5d450e1b&scoped=true&"
import script from "./SharedLinkDeleteDialogBox.vue?vue&type=script&lang=js&"
export * from "./SharedLinkDeleteDialogBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d450e1b",
  null
  
)

export default component.exports